import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../service";
import classes from './NewProject.module.css'


const NewProject = ({ closePopup, addNewProject, createNewProject }) => {
    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const [newProject, setNewProject] = useState({ id: null, name: null, isAllowed: false, description: null })
    const [ides, setIdes] = useState()

    useEffect(() => {
        if (uiData) {
           setIdes(uiData.ides)
        }
    }, [uiData])

    const changeNewProject = (key, val) => {
        setNewProject((prevNewProject) => {
            let newNewProject = { ...prevNewProject }
            newNewProject[key] = val
            if (newNewProject.id && newNewProject.name) {
                newNewProject.isAllowed = true
                return newNewProject
            } else {
                newNewProject.isAllowed = false
                return newNewProject
            }
        })
    }

    const HandlecreateNewProject = (newProject) => {
        if (newProject.isAllowed) {
            createNewProject(newProject);
            closePopup();
        }
    }

    useEffect(() => {
        const tabIndexes = document.querySelectorAll('[tabindex]');
        let arr = [];
        tabIndexes.forEach(ti => {
            if (ti.id != "popup") {
                ti.tabIndex = "-1";
                arr.push(ti);
            }
        })
        return () => {
            const tabIndexes = document.querySelectorAll('[tabindex]');
            let arr = [];
            tabIndexes.forEach(ti => {
                ti.tabIndex = "0";
                arr.push(ti);
            })
        }
    }, [])

    return (
        <>
            <div className={classes.BackDrop}>
                <div className={classes.NewProjectWrapper}>
                    <div className={classes.NewProject}>
                        <div className={classes.Header}>
                            <div className={classes.Title}>{texts.createNewProject}</div>
                            <div className={classes.Circle} onClick={(e) => closePopup(e)} tabIndex="0" id="popup" role="button" onKeyDown={e => onKeyDown(e, () => closePopup(e))}>
                                <div className={classes.XLine}></div>
                                <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                            </div>
                        </div>
                        <h2 className={classes.ChooseIDE}>{texts.chooseIDE}</h2>
                        <div className={classes.IDEs}>
                            {ides && ides.map((ide, i) =>
                                <div className={`${classes.IDEWrapper} ${newProject.id && newProject.id === ide.id ? classes.CurrentIde : ``}`} onClick={() => changeNewProject("id", ide.id)} key={i} tabIndex="0" id="popup" role="button" onKeyDown={e => onKeyDown(e, () => changeNewProject("id", ide.id))}>
                                    <img className={classes.IDEContent} src={ide.backgroundImage} alt="IdeIcon" />
                                </div>
                            )}
                        </div>
                        <div className={classes.Inputs}>
                            <input type='text' placeholder={texts.giveNewName} name="newProjectName" className={classes.NewNameInput} onChange={(e) => changeNewProject("name", e.target.value)} ></input>
                            <input type='text' placeholder={texts.giveDesc} name="newProjectDesc" className={`${classes.NewNameInput} ${classes.DescInput}`} onChange={(e) => changeNewProject("description", e.target.value)} ></input>
                        </div>
                        <div className={classes.CreateBtn} onClick={() => HandlecreateNewProject(newProject)} tabIndex="0" id="popup" role="button" onKeyDown={e => onKeyDown(e, () => HandlecreateNewProject(newProject))} style={{ cursor: newProject.isAllowed ? "pointer" : "not-allowed" }}>{texts.create}</div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default NewProject